import request from '@/utils/request'

const userApi = {
  Login: '/login',
  PhoneLogin: '/phoneLogin',
  Logout: '/logout',
  Register: '/register',

  // get my info
  UserInfo: '/getInfo'
}

/**
 * login func
 * @param parameter
 * @returns {*}
 */
export function login(parameter) {
  return request({
    url: userApi.Login,
    method: 'post',
    data: parameter
  })
}
/**
 * 手机登录
 * @param parameter
 * @returns {*}
 */
export function phoneLogin(parameter) {
  return request({
    url: userApi.PhoneLogin,
    method: 'post',
    data: parameter
  })
}
// 注册方法
export function register(data) {
  return request({
    url: userApi.Register,
    headers: {
      isToken: false
    },
    method: 'post',
    data: data
  })
}

export function getInfo() {
  return request({
    url: userApi.UserInfo,
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function logout() {
  return request({
    url: userApi.Logout,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

// 获取验证码
export function getCodeImg(query) {
  return request({
    url: '/captchaImage?corpId=' + query.corpId,
    method: 'get'
  })
}
// 获取手机验证码
export function getCodePhone(query) {
  return request({
    url: `/getCode/${query.phone}?corpId=${query.corpId}`,
    method: 'get'
  })
}
// 扫码登录获取token
export function tokenByTimeStamp(parameter) {
  return request({
    url: '/getTokenByTimeStamp?timeStamp=' + parameter,
    method: 'post'
  })
}

// 获取用户设备审批状态
export function getLoginStatus(query) {
  return request({
    url: `/system/userAuth/status`,
    method: 'get',
    params: query
  })
}
// 新增用户设备审批
export function checkMacAdress(query) {
  return request({
    url: '/system/userAuth',
    method: 'post',
    data: query
  })
}

